import { httpRequest } from "../../http";

export interface FontVariant {
    id: number | null;
    weight: number;
    italic: boolean;
    format: string;
    variable: boolean;
    axes_json: { tag: string; min: number; max: number; default: number }[] | null;
    file_url: string;
}

export interface FontFamily {
    family_name: string;
    source: string;
    variants: FontVariant[];
}

export class CommandGetFontFamilies {
    async run(source: string, search?: string): Promise<FontFamily[]> {
        let url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/fonts/?source=${encodeURIComponent(source)}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        try {
            const response = await httpRequest<FontFamily[]>(url, { method: "GET" });
            return response;
        } catch (error) {
            console.error("Error fetching font families:", error);
            throw error;
        }
    }
}
